import * as React from 'react';
import Icon from '../../../../icons/Icon';

export default class CampingIcon extends Icon {
    renderIcon() {
        return (
            <svg width={this.getSize()} height={this.getSize()} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0" y="0" viewBox="0 0 300 300">
                <circle className="st0" cx="150" cy="150" r="141"/>
                <polyline className="st1" points="215.1,146.6 215.1,196.6 150,196.6 150,118 105.1,167.9 125.4,182.3 125.4,196.6 84.9,196.6
	84.9,146.6 "/>
                <polyline className="st1" points="48.6,183.3 150,81.8 251.4,183.3 "/>
                <line className="st1" x1="125.4" y1="182.3" x2="150" y2="118"/>
                <line className="st1" x1="50.2" y1="173.3" x2="63.1" y2="196.6"/>
                <line className="st1" x1="250.9" y1="173.3" x2="238" y2="196.6"/>
            </svg>
        );
    }
}